export default __webpack_public_path__ + "static/media/MCSW-welder.7d5639fb.png";